var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series)?_c('apexchart',{attrs:{"type":"line","width":"100%","height":"350","options":_vm.chartOptions,"series":_vm.series}}):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }